const descriptionLabels = new Map([
  ['all systems operational', 'Online'],
  ['systems operational', 'Online'],
  ['partially degraded service', 'Degraded'],
  ['degraded service', 'Degraded'],
  ['degraded system service', 'Degraded'],
  ['minor service outage', 'Limited'],
  ['partial system outage', 'Limited'],
  ['major system outage', 'Offline'],
  ['service under maintenance', 'Maintenance'],
  ['system under maintenance', 'Maintenance']
])

const indicatorLabels = new Map([
  ['none', 'Online'],
  ['minor', 'Degraded'],
  ['major', 'Limited'],
  ['critical', 'Offline'],
  ['maintenance', 'Maintenance']
])

export const homeStatusLabel = status => {
  if (!status) return ''
  const description = typeof status.description === 'string'
    ? status.description.trim().toLowerCase()
    : ''
  // Prefer the description: both degraded service and minor outages use "minor".
  return descriptionLabels.get(description) || indicatorLabels.get(status.indicator) || ''
}
